<ng-container *ngIf="videoData">
  <div
    class="video-card"
    inViewport
    (elementIsVisible)="loadMoreIfLastIndex()"
    [lastElement]="lastElement"
  >
    <app-action-menu
      *ngIf="showMenu"
      [isOpen]="isMenuOpen"
      (open)="openMenuEmitter.emit()"
      (outsideClick)="closeMenuEmitter.emit()"
      (edit)="handleEditBlog(videoData.id)"
      (delete)="onDeleteVideoEmitter.emit(videoData.id)"
    ></app-action-menu>
    <picture (click)="videoPlay.emit()">
      <ng-container *ngIf="!showFallBackImage; else fallbackImageTemp">
        <img
          [src]="videoData.thumbnailUrl"
          [alt]="videoData.title"
          (error)="handleErrorOnImage($event)"
      /></ng-container>

      <a class="flex align-center justify-center">
        <img src="assets/images/play.svg" alt="Play" />
      </a>
    </picture>

    <h4>{{ videoData.title }}</h4>
    <p>
      {{ videoData.description }}
    </p>
    <span>{{ videoData.createdAt | date : "MMMM d, y" }}</span>
  </div>
</ng-container>

<ng-template #fallbackImageTemp>
  <img src="assets/images/video-fallback.svg" alt="thumbnail" />
</ng-template>
